import { COOKIE_CONSENT_LANGUAGES, Language } from 'root-constants/common'

// TODO: should be deleted after translate cookie banner on AR and ZH
export const hasAnalyticsByLocale = (language: Language) =>
  !COOKIE_CONSENT_LANGUAGES.includes(language)
